// extracted by css-extract-rspack-plugin
export default {"cls1":"LettersModal-cls1_2JB","cls2":"LettersModal-cls2_8fj LettersModal-cls1_2JB"};